// Overview API — fetches platform-wide KPI aggregate from the support backend.
// Follows the same USE_MOCK convention as customers/api.ts and catalogue/api.ts.

import { api } from "@/shared/api/client";
import type { OverviewStats } from "./types";
import { mockOverview } from "./mock";

// ── Mock toggle ──────────────────────────────────────────────────────────────
// The backend GET /api/support/overview/ endpoint is built in parallel (subtask 04).
// Until it is live the UI runs against mockOverview() which mirrors the exact contract.
// FLIP TO REAL: set VITE_USE_MOCK=false (or remove it) — no other change needed.
const USE_MOCK =
  (import.meta.env.VITE_USE_MOCK ?? "true").toString().toLowerCase() !== "false";

// Small latency so the loading states are exercised in mock mode.
const delay = (ms = 250) => new Promise<void>((r) => setTimeout(r, ms));

// ── Data function ─────────────────────────────────────────────────────────────

/** Fetch platform-wide overview stats from the support API (or mock). */
export async function getOverview(): Promise<OverviewStats> {
  if (USE_MOCK) {
    await delay();
    return mockOverview();
  }
  const res = await api.get<OverviewStats>("/support/overview/");
  return res.data;
}
